/*
 *
 * ----------------------------------------------- */
export function isMobile() {
  var isMobile = false;

  jQuery(function ($) {
    var breakpoint = 768;
    updateIsMobile();

    $(window).on('resize load', function () {
      updateIsMobile()
    });

    function updateIsMobile() {
      isMobile = $(window).width() < breakpoint;
    }
  });

  return isMobile;
}
